APPS.landingPages.digital = (function(){
    var show = function(){
            APP.getView().showChildView('mainRegion', new pageView({}) )
            
            window.document.title = "WHRO Digital";
            if(typeof ga != "undefined"){ ga('send','pageview',{ title:"WHRO Digital", page:"/digital" }) }
			if(typeof gtag != "undefined"){ gtag('event', 'page_view', { 'page_title': "WHRO Digital", 'page_path': '/digital', 'page_location': window.location.origin+"/digital" }); }
            if(typeof submitVisitorDetails ==="function"){ submitVisitorDetails(APP_CONFIG.rpi.server, APP_CONFIG.rpi.clientId, "WHRO Digital", '0', false, true); }
    }

    /* VIEWS */
    // THE PAGE
    var pageView = Marionette.View.extend({
         template:"#tmpl-landingPage-digital"
        ,className:"page_landingPage_digital"
        ,templateContext:function(){
	        
        }
        ,events:{
            //'click .stationPlaylistHeader':'togglePlaylistSection'
        }
        ,onAttach:function(){
	        
        }
    })
    
    

    return {
        show:show
    }
})();


